module.exports = __webpack_public_path__ + "static/media/sos-logo.312e9935.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/clients/sos-logo.jpg
 ** module id = 776
 ** module chunks = 0
 **/